export function messageIdToExpression(messageId) {
    return `$_(${messageId})`;
}
export function expressionToMessageId(expression) {
    return expression.replace(/^\$_\(/, '').replace(/\)$/, '');
}
